import { metaAccount } from '@/router/meta-config'
const permissionKey = 'AUDIOGUIDE'

export default [
  {
    path: '/audioguides',
    name: 'page-audioguides',
    component: () => import('@/pages/audioguides'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/audioguide/new',
    name: 'page-audioguide-new',
    component: () => import('@/pages/audioguide'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/audioguide/:id',
    name: 'page-audioguide',
    component: () => import('@/pages/audioguide'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
